import { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import SplitPanel from "@amzn/awsui-components-react/polaris/split-panel";

import { ManageOrdersTable } from "../../components/ManageOrders";
import NavigationBreadcrumbs from "../../common/navigation/NavigationBreadcrumbs";
import SideNavigationMenu from "../../common/navigation/SideNavigationMenu";

import Paths from "../../common/paths/paths";
import { Flashbar } from "@amzn/awsui-components-react";
import { useFlashBarItems } from "../../common/UseFlashBarItems/useFlashBarItems";
import { getString } from "../../common/ui-string-labels/ui-strings-utils";
import { SplitPanelPreferencesChangeEvent, SplitPanelToggleEvent } from "../../components/ChatbotWidget/interfaces";
import useAppDrawers from "../../components/ChatbotWidget/useAppDrawers";
import OrderDetailsSidePanel from "components/ManageOrders/OrderSidePanel";
import { useDetailsSidePanel, useManageOrdersTable } from "components/ManageOrders/useManageOrdersTable";

import { useLocation } from "react-router-dom";

const OrdersUploadedPage = () => {
    const location = useLocation();
    let fileGuid = "";
    let fileName = "";
    if (location.state) {
        fileGuid = location.state.fileGuid;
        fileName = location.state.fileName;
    }

    const breadcrumbs = {
        items: [
            { text: Paths.Admin.name, href: Paths.uploadLicense.url },
            { text: Paths.manageOrders.name, href: Paths.manageOrders.url },
            { text: fileName, href: "#" },
        ],
    };

    const [navigationOpen, setNavigationOpen] = useState(false);
    const flashBarItemsHook = useFlashBarItems();
    const detailsSidePanelHook = useDetailsSidePanel();
    const useManageOrdersTableHook = useManageOrdersTable();
    const [splitPanelPosition, setSplitPanelPosition] = useState<"bottom" | "side">("bottom");
    const drawerProps = useAppDrawers();

    return (
        <AppLayout
            headerSelector="#top-nav"
            content={
                <ManageOrdersTable
                    useFlashBarItemsActions={flashBarItemsHook.actions}
                    useDetailsSidePanel={detailsSidePanelHook}
                    useManageOrdersTableHook={useManageOrdersTableHook}
                    fileId={fileGuid}
                    fileName={fileName}
                />
            }
            breadcrumbs={<NavigationBreadcrumbs items={breadcrumbs.items} />}
            navigation={<SideNavigationMenu />}
            navigationOpen={navigationOpen}
            splitPanel={
                detailsSidePanelHook.isOpened ? (
                    <SplitPanel
                        header={detailsSidePanelHook.selectedOrder?.display || getString('manageOrders.splitPanel.title')}
                        i18nStrings={{
                            preferencesTitle: getString('manageOrders.splitPanel.preferencesTitle'),
                            preferencesPositionLabel: getString('manageOrders.splitPanel.positionLabel'),
                            preferencesPositionDescription: getString('manageOrders.splitPanel.positionDescription'),
                            preferencesPositionBottom: getString('manageOrders.splitPanel.positionBottom'),
                            preferencesPositionSide: getString('manageOrders.splitPanel.positionSide'),
                            preferencesCancel: getString('manageOrders.splitPanel.cancel'),
                            preferencesConfirm: getString('manageOrders.splitPanel.confirm'),
                            openButtonAriaLabel: getString('manageOrders.splitPanel.openButtonAriaLabel'),
                            closeButtonAriaLabel: getString('manageOrders.splitPanel.closeButtonAriaLabel'),
                        }}
                    >
                        <OrderDetailsSidePanel selectedOrder={detailsSidePanelHook.selectedOrder} />
                    </SplitPanel>
                ) : undefined
            }
            splitPanelOpen={detailsSidePanelHook.isOpened}
            onSplitPanelToggle={(event: SplitPanelToggleEvent) => {
                if (!event.detail.open) {
                    detailsSidePanelHook.actions.hidePanel();
                    useManageOrdersTableHook.actions.refreshAttributes();
                }
            }}
            splitPanelPreferences={{ position: splitPanelPosition }}
            onSplitPanelPreferencesChange={(event: SplitPanelPreferencesChangeEvent) => setSplitPanelPosition(event.detail.position)}
            notifications={<Flashbar items={flashBarItemsHook.flashBarItems} stackItems />}
            onNavigationChange={(event: any) => setNavigationOpen(event.detail.open)}
            {...drawerProps}
        />
    );
};

export default OrdersUploadedPage;
